<template>
  <div class="flinks">
    <AppSpinner
      v-if="iframeLoading"
    />

    <div class="flinks__iframe-container">
      <iframe
        v-show="!iframeLoading"
        :src="`${baseUrl}${redirectParams}`"
        class="flinks__iframe"
        frameborder="0"
        height="555"
        width="100%"
        @load="iframeLoading = false"
      />
    </div>

    <div
      v-if="flinksConnecting"
      class="flinks__loading"
    >
      Hang tight, we are connecting to your bank account.
    </div>
  </div>
</template>

<script>
import AppSpinner from '@/components/common/spinners/AppSpinner'
import qs from 'qs'

export default {
  // Name
  name: 'flinks-iframe',

  // Components
  components: {
    AppSpinner
  },

  // Data
  data () {
    const queryParams = {
      theme: 'light',
      customerName: 'Canada Drives',
      termsUrl: 'https://canadadrives.ca/flinks-end-user-agreement',
      innerRedirect: true,
      backEnable: true,
      daysOfTransactions: process.env.VUE_APP_FLINKS_DAYS_OF_TRANSACTIONS || 'Days90'
    }

    return {
      iframeLoading: true,
      flinksConnecting: false,
      baseUrl: process.env.VUE_APP_FLINKS_BASE_URL,
      redirectParams: '?' + qs.stringify(queryParams)
    }
  },

  // Created
  created () {
    // listener for message events that flinks broadcasts
    window.addEventListener('message', this.handleMessageEvent)

    // Fix for weird iOS iframe scroll / click bug
    window.addEventListener('touchstart', {})
  },

  // Before Destroy
  beforeDestroy () {
    window.removeEventListener('message', this.handleMessageEvent)
  },

  // Methods
  methods: {
    /**
     * Handle the Message event from the iframe
     * (Other sources can throw these messages too, such as Vue Dev tools)
     * $emit the bank-ready event & payload if loginId (successfully verified)
     * @param {MessageEvent} - event
     * @emits bank-ready
     */
    handleMessageEvent ({ data }) {
      const loginId = data.loginId
      const isRedirect = data.step && data.step === 'REDIRECT'

      // display "hang tight" connection message below iframe while Flinks connects
      if (data.step === 'SUBMIT_CREDENTIAL') {
        this.flinksConnecting = true
      }

      // loginId + 'REDIRECT' step represents a successful connection to Flinks
      if (loginId && isRedirect) {
        this.flinksConnecting = false
        const flinksCode = data.step || ''
        const institution = data.institution || ''

        // $emit account info from Flinks to <BankVerificationContent />
        this.$emit('bank-ready', {
          loginId,
          flinksCode,
          institution
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flinks {
  &__loading {
    text-align: center;
    color: $theme-text-grey-dark;
    margin-top: 15px;
  }

  &__iframe-container {
    display: flex;
    flex-direction: column;
    max-width: 330px;
    margin: auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
  }
}
.app-spinner {
  justify-content: center;
}
</style>
